define('viewmodels/pages/cash/ChooseMethodViewModel',['underscore', 'knockout'], function(_, ko) {

    /**
     * @param {string} view
     * @param {ObservableArray of UsablePaymentMethod} methods
     * @param {Observable of UsablePaymentMethod} currentMethod
     * @param {function} callback to be called when a selection is made
     */
    function ChooseMethodViewModel(view, methods, currentMethod, onSelect) {

        this.view = view;

        this.methods = methods
            .pipe(Array, function (methods) {
                return _.sortBy(methods, function (method) {
                    var mobileGrouping = method.specificMethod().getProfile().grouping().mobile,
                        name = mobileGrouping.name,
                        order = mobileGrouping.order;

                    if (!method.isTemporary) {
                        return -1;
                    }

                    return name === 'preferred' ? order : order + 100;
                });
            })
            .map(function (method) {
                return _.extend({}, method, {
                    select: function () {

                        if (method.isTemporary) {
                            currentMethod(method.copy());
                        } else {
                            currentMethod(method);
                        }

                        if (_.isFunction(onSelect)) {
                            onSelect(method);
                        }
                    },
                    isSelected: ko.pureComputed(function() {
                        return currentMethod() === method;
                    })
                });
            });
    }

    ChooseMethodViewModel.prototype.getView = function() {
        return this.view;
    };

    return ChooseMethodViewModel;

});

